import { Alert, AlertAction, AlertTitle } from '@nesso/ui/primitives/alert';
import { Button } from '@nesso/ui/primitives/button';

type PlanBillingErrorAlertProps = {
    onBillingDetails: () => void;
};

export function PlanBillingErrorAlert({ onBillingDetails }: PlanBillingErrorAlertProps) {
    return (
        <Alert variant="base" className="items-center p-6 gap-x-0 mb-8">
            <AlertTitle>Unable to load billing information. Try again later</AlertTitle>
            <AlertAction className="@lg:row-span-1 @lg:self-center">
                <Button variant="outline" size="sm" onClick={onBillingDetails}>
                    Billing Details
                </Button>
            </AlertAction>
        </Alert>
    );
}
